import { render } from "./DesktopHeader.vue?vue&type=template&id=9d35f880&ts=true"
import script from "./DesktopHeader.vue?vue&type=script&lang=ts"
export * from "./DesktopHeader.vue?vue&type=script&lang=ts"

import "./DesktopHeader.vue?vue&type=style&index=0&id=9d35f880&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__